export class LojaVendedor {
  lojaId: number;
  vendedorId: number;
  promotorId: number;
}
